import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Globle } from 'src/assets/globle';
import { QRCategories } from './qrCategories.model';
import { QrcommissioncategoriesService } from './qrcommissioncategories.service';

@Component({
  selector: 'app-qrcommissioncategories',
  templateUrl: './qrcommissioncategories.component.html',
  styleUrls: ['./qrcommissioncategories.component.css'],
  queries: {
    contentRef: new ViewChild("Modal"),
    contentRef1: new ViewChild("ModalAddUpdate")
  },
})
export class QrcommissioncategoriesComponent implements OnInit {

  qrCategoriesList: QRCategories[] = [];
  displayedColumns: string[] = ['id', 'fromAmount', 'toAmount', 'commission', "edit", "delete"];
  dataSource!: MatTableDataSource<QRCategories>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;
  qrCategory: QRCategories = {} as QRCategories;
  Advstatus: { id: number, name: string }[] = [];
  selectedStatus: number = 1
  imagPath: any;
  pageSize = 100;
  updateMode = false;

  constructor(private service: QrcommissioncategoriesService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private globle: Globle,
    private translate: TranslateService) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.get();
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getAll().subscribe(data => {
      this.qrCategoriesList = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.qrCategoriesList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  createNew() {
    this.qrCategory = {} as QRCategories;
    this.updateMode = false;
    this.openDialogAddUpdate();


  }

  edit(qrCategory: QRCategories) {
    this.qrCategory = qrCategory;
    this.updateMode = true;
    this.openDialogAddUpdate();

  }

  onDelete(id: number) {
    this.qrCategory.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.Delete(this.qrCategory.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.get();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectChange() {
    this.get();
  }

  openDialogAddUpdate(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '300px',
    });
  }

  save() {
    if (!this.updateMode) {
      this.addNew()
    }
    else {
      this.update();
    }
  }

  addNew() {
    this.spinnerOverlay = true;
    this.service.Create(this.qrCategory).subscribe(data => {
      this.dialog.closeAll();
      this.openSnackBar(this.translate.instant("createdSuccessfully"), 'snackBarSuccess');
      this.get();
    })
  }

  update() {
    this.spinnerOverlay = true;
    this.service.Update(this.qrCategory).subscribe(data => {
      this.dialog.closeAll();
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.get();
    })
  }

}
